import SignupFormModel from './SignupFormModel'

const {
  formField: {
    firstName,
    lastName,
    email,
    password,
    profileType,
    postalCode,
    country,
    photo,
    heroImage,
    about,
    title,
    employmentStatus,
    step,
  },
} = SignupFormModel

// const values = {
//   [firstName.name]: 'Andrew',
//   [lastName.name]: 'Scofield',
//   [email.name]: 'andrew152@beldenstreet.com',
//   [password.name]: '1234',
//   [profileType.name]: '',
//   [country.name]: 'US',
//   [postalCode.name]: '63026',
//   [photo.name]:
//     'https://res.cloudinary.com/beldenst/image/upload/v1660074489/titan/cncexpert/users/andrew%2Baug17%40beldenstreet.com/avatar_andrew%2Baug17%40beldenstreet.com.jpg',
//   [heroImage.name]: 'space2.jpg',
//   [about.name]: 'Adipisicing eiusmod incididunt cillum labore elit eiusmod magna non non Lorem ex fugiat.',
//   [title.name]: 'Test Title',
//   [employmentStatus.name]: 'seeking',
//   [step.name]: '',
// }

const values = {
  [firstName.name]: '',
  [lastName.name]: '',
  [email.name]: '',
  [password.name]: '',
  [profileType.name]: '',
  [country.name]: '',
  [postalCode.name]: '',
  [photo.name]: '',
  [heroImage.name]: '',
  [about.name]: '',
  [title.name]: '',
  [employmentStatus.name]: '',
  [step.name]: '',
}

export default values
